import { QueueItemCard } from './QueueItemCard';
import type { UploadQueueItem } from '../types';

// Aparición animada de cada thumbnail (fade + leve escala/subida). La clase queda
// inerte bajo `prefers-reduced-motion: reduce`: el @keyframes solo aplica cuando el
// usuario NO pidió reducir movimiento. Cada card monta con su propia animación, así
// que al agregar archivos el usuario VE entrar cada foto en vez de que "aparezcan".
const QUEUE_ITEM_KEYFRAMES = `
@keyframes sm-queue-item-in {
  from { opacity: 0; transform: translateY(6px) scale(0.94); }
  to { opacity: 1; transform: translateY(0) scale(1); }
}
@media (prefers-reduced-motion: no-preference) {
  .sm-queue-item-animate { animation: sm-queue-item-in 240ms cubic-bezier(0.22, 1, 0.36, 1) both; }
}`;

export interface FileQueueGridProps {
  items: UploadQueueItem[];
  onRemove: (id: string) => void;
  onRetry: (id: string) => void;
}

export function FileQueueGrid({ items, onRemove, onRetry }: FileQueueGridProps) {
  if (items.length === 0) return null;

  return (
    <>
      <style>{QUEUE_ITEM_KEYFRAMES}</style>
      <div
        data-testid="file-queue-grid"
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fill, minmax(96px, 1fr))',
          gap: 12,
          width: '100%',
        }}
      >
        {items.map((item) => (
          <QueueItemCard key={item.id} item={item} onRemove={onRemove} onRetry={onRetry} />
        ))}
      </div>
    </>
  );
}
